import React, { FunctionComponent } from 'react';
import grey from '@material-ui/core/colors/grey';
import { makeStyles, createStyles, Button, Box, Grid, OutlinedInput } from '@material-ui/core';

type AddCommentFieldProps = {
    isAddCommentFieldOpen: boolean;
    setAddCommentFieldOpen: Function;
    setComment: Function;
    handleAddCommentChange: Function;
    handleChangeComment: Function;
    disabled: boolean;
};

const AddCommentField: FunctionComponent<AddCommentFieldProps> = (props) => {
    const {
        isAddCommentFieldOpen,
        setAddCommentFieldOpen,
        setComment,
        handleAddCommentChange,
        handleChangeComment,
        disabled,
    } = props;

    const useStyles = makeStyles(() =>
        createStyles({
            addCommentDialogValue: {
                fontSize: 14,
                fontWeight: 450,
                color: grey[600],
                width: '100%',
                lineHeight: '21px',
            },
            addCommentDialogMain: {
                width: '83%',
                justifyContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
            },
            cancelBtn: {
                marginLeft: 20,
            },
            toggleBtn: {
                border: '1px solid rgba(0,0,0,0.23)',
                width: '100%',
                height: '60px',
                justifyContent: 'start',
                color: '#6E7788',
                paddingLeft: '20px',
            },
            btnContainer: {
                marginTop: 25,
            },
            underline: {
                borderBottomColor: 'white',
                '&:before': {
                    borderBottomColor: 'white',
                },
                '&:after': {
                    borderBottomColor: 'white',
                },
                '&:hover:before': {
                    borderBottomColor: ['white', '!important'],
                },
            },
            MuiOutlinedInput: {
                backgroundColor: 'white',
                border: '1px solid #ced4da',
                borderRadius: 5,
                '&:focus': {
                    backgroundColor: 'white',
                    border: '1px solid #ced4da',
                },
                '&:hover': {
                    backgroundColor: ['white', '!important'],
                    border: '1px solid #ced4da',
                },
            },
        }),
    );
    //@ts-ignore
    const classes = useStyles();
    return (
        <Box component="div" className={classes.addCommentDialogMain}>
            {isAddCommentFieldOpen ? (
                <Grid container style={{ marginTop: '10px' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box className={classes.addCommentDialogValue}>
                            <OutlinedInput
                                id="comments"
                                fullWidth={true}
                                value={null}
                                inputProps={{
                                    classes: {
                                        root: classes.MuiOutlinedInput,
                                        underline: classes.underline,
                                    },
                                }}
                                multiline={true}
                                rows={5}
                                onChange={(e) => {
                                    handleChangeComment(e);
                                }}
                                autoFocus={true}
                            />
                        </Box>
                    </Grid>
                    <Grid className={classes.btnContainer} sm={12} md={12} lg={12} item>
                        <Box display="flex" justifyContent="flex-start">
                            <Button
                                onClick={() => {
                                    handleAddCommentChange();
                                }}
                                variant="contained"
                                color="primary"
                                disabled={disabled}
                            >
                                ADD COMMENT
                            </Button>
                            <Button
                                onClick={() => {
                                    setAddCommentFieldOpen(false);
                                    setComment('');
                                }}
                                className={classes.cancelBtn}
                            >
                                CANCEL
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            ) : (
                <Grid container style={{ marginTop: '10px' }}>
                    <Box className={classes.addCommentDialogValue}>
                        <Button
                            onClick={() => {
                                setAddCommentFieldOpen(true);
                            }}
                            className={classes.toggleBtn}
                        >
                            Add Comment
                        </Button>
                    </Box>
                </Grid>
            )}
        </Box>
    );
};

export default AddCommentField;
